import { Injectable } from "@angular/core";
import { BaseHandler } from "@app/core/shared/data/network/base-handler";
import { Observable, map } from "rxjs";
import { TokenAuthorization } from "@app/core/shared/data/network/token-authorization";
import { ApiUrls } from "@app/core/shared/data/network/api-urls";
import {
  HandlerBuilder,
  HttpMethod,
} from "@app/core/shared/data/network/base-handler.parameters";
import { MarketingMessage } from "@app/core/marketing/domain/marketing-message";
import { GetMarketingMessageMapper } from "@app/core/marketing/data/network/get-marketing-message.mapper";

/**
 * Web service used to get match detail.
 */
@Injectable({
  providedIn: "root",
})
export class GetMarketingMessageWS {
  constructor(private handler: BaseHandler) {}
  execute(token: string): Observable<MarketingMessage> {
    const parameters = new HandlerBuilder()

      .setUrl(ApiUrls.GET_MARKETING_MESSAGE_ENDPOINT())
      .setMethod(HttpMethod.get)
      .setAuthorization(new TokenAuthorization(token))
      .build();
    return this.handler
      .execute(parameters)
      .pipe(map((response) => GetMarketingMessageMapper.deserialize(response)));
  }
}
